import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 32, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.8, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

export const ChapterTag = ({ num, label, dark = false }) => (
  <span
    className={`inline-flex items-center gap-3 font-mono text-xs font-bold tracking-[0.25em] uppercase ${
      dark ? "text-brand-yellow" : "text-brand-ink"
    }`}
  >
    <span className={`h-px w-8 ${dark ? "bg-brand-yellow" : "bg-brand-ink"}`} />
    {num} — {label}
  </span>
);
